module.exports = __webpack_public_path__ + "media/character-dog-happy.71d0c3af.mp3";